/* Generated. This file cannot be edited directly. Please check codegen.ts for configuration. */
// @ts-nocheck

import * as Apollo from '@apollo/client'

import { gql } from '@apollo/client'
import * as Types from '../../../../../../graphql/src/lib/graphql/generated/types'

const defaultOptions = {} as const
export type AdVehicleStreamCabinSafetyCheckVehicleFragment = {
  __typename?: 'Vehicle'
  id: string
  fccCurrentAdAlerts: {
    __typename?: 'FccAdAlerts'
    alerts: Array<{
      __typename?: 'FccAdAlert'
      id: string
      type: Types.FccAdAlertType
      visibleTo: Array<Types.FccOperatorRoleType>
    }>
  } | null
  adSeatsLayout: {
    __typename?: 'FccSeatLayout'
    thirdRowRight: {
      __typename?: 'FccSeat'
      occupancy: Types.FccSeatOccupancy
      seatbelt: Types.FccSeatbelt
    }
    thirdRowMiddle: {
      __typename?: 'FccSeat'
      occupancy: Types.FccSeatOccupancy
      seatbelt: Types.FccSeatbelt
    }
    thirdRowLeft: {
      __typename?: 'FccSeat'
      occupancy: Types.FccSeatOccupancy
      seatbelt: Types.FccSeatbelt
    }
    secondRowRight: {
      __typename?: 'FccSeat'
      occupancy: Types.FccSeatOccupancy
      seatbelt: Types.FccSeatbelt
    }
    secondRowMiddle: {
      __typename?: 'FccSeat'
      occupancy: Types.FccSeatOccupancy
      seatbelt: Types.FccSeatbelt
    }
    secondRowLeft: {
      __typename?: 'FccSeat'
      occupancy: Types.FccSeatOccupancy
      seatbelt: Types.FccSeatbelt
    }
  } | null
  vehicleStatusTelemetry?: {
    __typename?: 'VehicleStatusVehicleTelemetry'
    doorState: {
      __typename?: 'VehicleStatusDoorStates'
      states: Array<{
        __typename?: 'VehicleStatusDoorStateSignal'
        position: Types.VehicleStatusDoorPosition
        state: Types.VehicleStatusDoorState
        updatedAt: string
      }>
    }
  } | null
}

export type AdVehicleStreamConfirmCabinSafetyMutationVariables = Types.Exact<{
  vehicleId: Types.Scalars['ID']['input']
}>

export type AdVehicleStreamConfirmCabinSafetyMutation = {
  __typename?: 'Mutation'
  fccConfirmCabinSafety: any | null
}

export const AdVehicleStreamCabinSafetyCheckVehicleFragmentDoc = gql`
    fragment AdVehicleStreamCabinSafetyCheckVehicle on Vehicle {
  id
  fccCurrentAdAlerts {
    alerts {
      ...UseAlertsForRoleAdAlert
      id
      type
    }
  }
  ...AdVehicleStreamAdVehicleSeatingVehicle
  ...AdVehicleStreamAdVehicleDoorStatus
}
    `
export const AdVehicleStreamConfirmCabinSafetyDocument = gql`
    mutation AdVehicleStreamConfirmCabinSafety($vehicleId: ID!) {
  fccConfirmCabinSafety(input: {vehicleId: $vehicleId, actor: REMOTE_OPERATOR})
}
    `
export type AdVehicleStreamConfirmCabinSafetyMutationFn =
  Apollo.MutationFunction<
    AdVehicleStreamConfirmCabinSafetyMutation,
    AdVehicleStreamConfirmCabinSafetyMutationVariables
  >

/**
 * __useAdVehicleStreamConfirmCabinSafetyMutation__
 *
 * To run a mutation, you first call `useAdVehicleStreamConfirmCabinSafetyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdVehicleStreamConfirmCabinSafetyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adVehicleStreamConfirmCabinSafetyMutation, { data, loading, error }] = useAdVehicleStreamConfirmCabinSafetyMutation({
 *   variables: {
 *      vehicleId: // value for 'vehicleId'
 *   },
 * });
 */
export function useAdVehicleStreamConfirmCabinSafetyMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AdVehicleStreamConfirmCabinSafetyMutation,
    AdVehicleStreamConfirmCabinSafetyMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    AdVehicleStreamConfirmCabinSafetyMutation,
    AdVehicleStreamConfirmCabinSafetyMutationVariables
  >(AdVehicleStreamConfirmCabinSafetyDocument, options)
}
export type AdVehicleStreamConfirmCabinSafetyMutationHookResult = ReturnType<
  typeof useAdVehicleStreamConfirmCabinSafetyMutation
>
export type AdVehicleStreamConfirmCabinSafetyMutationResult =
  Apollo.MutationResult<AdVehicleStreamConfirmCabinSafetyMutation>
export type AdVehicleStreamConfirmCabinSafetyMutationOptions =
  Apollo.BaseMutationOptions<
    AdVehicleStreamConfirmCabinSafetyMutation,
    AdVehicleStreamConfirmCabinSafetyMutationVariables
  >
